export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getHouseTopConfigList: function getHouseTopConfigList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house/top/config/list",
        method: "get",
        params: data
      });
    },
    syncHouseTopCity: function syncHouseTopCity() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house/top/sync/city",
        method: "get",
        params: data
      });
    },
    updateHouseTopConfig: function updateHouseTopConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house/top/update/config",
        method: "post",
        data: data
      });
    },
    getHouseTopRecord: function getHouseTopRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house/top/record",
        method: "get",
        params: data
      });
    },
    getHouseTopList: function getHouseTopList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house/top/list",
        method: "get",
        params: data
      });
    },
    getMaxPromotionNumber: function getMaxPromotionNumber() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house/top/maxPromotionNumber",
        method: "get",
        params: data
      });
    }
  };
});